import ArticleBlock from 'libs/wordpress/content/cmsBlocks/ArticleFlowBlock';
import MaxWidthWrapper from 'components/wrappers/MaxWidthWrapper';
import React from 'react';
import moduleMargins from 'config/theme/moduleMargins';

const ArticleFlowLayout = ({ ...rest }) => (
    <MaxWidthWrapper includeContentMargins as="section" my={moduleMargins.md}>
        <ArticleBlock {...rest} />
    </MaxWidthWrapper>
);

export default ArticleFlowLayout;
